import React from 'react';
import styled, { keyframes } from 'styled-components';
import AbsoluteElement from '../DownTown/AbsoluteElement';

const CloudsContainer = AbsoluteElement('svg');

const CloudsShape = styled.path.attrs({
	d:
		'M1798.84,206.2c-73.49-64.89-201.44-41.14-291.52-37.3-43,1.84-152.22,29.58-189.72,12.55-30.13-13.68-53.79-61-93-77.13C1113,58.35,998.13,116.76,886,126.9c-70.68,6.39-139-.36-206.53-21.15l3.26,1c-36.25-18.44-34.13-65-71.47-87.31-55.39-33.1-233.55-29.3-227.72,46.17,3.57,46.1,76.44,73.63-12.7,113.57-83,37.18-247.64,14.1-338.53,9.46-112-5.71-229.17-43.59-339.93-8.25-104.86,33.46-167.23,131.33-12.06,131.66,70.21.15,591.83-105.37,552.54,46.72-22.76,88.13-199.33,37.73-259.88,54-39.6,10.62-75,11.24-62.47,65.09,17.32,74.62,157.17,48.54,218.08,49.28,42,.5,246.65,1.7,153.72,103.53-47.83,52.42-174.4-14.6-220.07,48.94-95.81,133.32,434,63.17,488.43,59.78,119.62-7.44,240.46-10.47,359.73-22,50.9-4.92,113.44-6,144.29-55.33,37.13-59.35,2.89-120.6-51.55-139.07-37.07-12.58-313,28.16-217.65-101.8,48.44-66.05,245.75-32.59,322.82-35,149.08-4.66,298.94-22.75,446.47-43.87C1592.41,336.94,1915,308.76,1798.84,206.2ZM962,590.7c.75-.17,1.57-.34,2.47-.52a20,20,0,0,0-2.91.85Zm-1.18.28a7.6,7.6,0,0,1-2.49,1.22A2.36,2.36,0,0,1,960.86,591Zm-2.09.57c-1.16,1.26-1.63,1-3.65,1.52A11.83,11.83,0,0,1,958.77,591.55ZM580.76,606c-52.92,68.5-239.24,8.8-159.16-78C466.47,479.33,653.57,511.76,580.76,606ZM775.07,360.72c-52.29,31.41-236.27,42-297,19-104.21-39.5-56.49-147.41,32.28-166.82,50-10.93,141.66-7.75,193.22-4.12C777.19,213.93,871.75,302.67,775.07,360.72Zm475.08-115.15c-6.36,84.9-141.12,104.62-198.18,57.6-119.77-98.7,96.77-194.14,180.83-118l-.13.1C1245.93,200.2,1251.66,225.47,1250.15,245.57Z',
	transform: 'translate(828 1) scale(2)',
	fill: 'transparent',
})``;

const cloudsAnimation = keyframes`
	from { background-position: 0px 0px; }
	to { background-position: -4474px 0px; }
`;

const CloudImage = AbsoluteElement('div', `
	width: 4474px;
	height: 1522px;
	background: url('/images/wurstbande/clouds.png') repeat-x 0 0;
	background-size: 4474px 1522px;
	animation: ${cloudsAnimation} 80s linear infinite;
	mix-blend-mode: multiply;
	clip-path: url(#clouds-shape);
`);

export default () => [
	<CloudsContainer
		width={4474}
		height={1522}
		viewBox="0 0 4474 1522"
		x={-400}
		y={-10}
		delay={1400}
		key="cloud-svg-shape"
	>
		<clipPath id="clouds-shape">
			<CloudsShape />
		</clipPath>
	</CloudsContainer>,
	<CloudImage
		x={-400}
		y={-10}
		delay={1400}
		key="cloud-png-image"
	/>,
];



// WEBPACK FOOTER //
// ./src/components/MagazineContent/Pages/Wurstbande/Clouds.js